module.exports = __webpack_public_path__ + "img/hero_portrait_barbarian_male.bd90ca2f.png";